import React, { useState, useEffect } from 'react';
import HeadHuntingBoard from '../apps/hunting';

const ShortList = () => {
  return (
    <div>
      <HeadHuntingBoard />
    </div>
  );
};

export default ShortList;
